var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25.0 25.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.31,0 C1.678,0 1.992,0.127 2.241,0.375 C2.492,0.624 2.619,0.937 2.619,1.304 C2.619,1.672 2.492,1.984 2.241,2.232 C1.991,2.481 1.678,2.608 1.31,2.608 C0.942,2.608 0.628,2.481 0.378,2.232 C0.127,1.984 0,1.672 0,1.304 C0,0.937 0.127,0.624 0.378,0.375 C0.627,0.127 0.941,0 1.31,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.31,0 C1.678,0 1.992,0.127 2.241,0.375 C2.492,0.624 2.619,0.937 2.619,1.304 C2.619,1.672 2.492,1.984 2.241,2.232 C1.991,2.481 1.678,2.608 1.31,2.608 C0.942,2.608 0.628,2.481 0.378,2.232 C0.127,1.984 0,1.672 0,1.304 C0,0.937 0.127,0.624 0.378,0.375 C0.627,0.127 0.941,0 1.31,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.309,0 C1.678,0 1.992,0.127 2.241,0.375 C2.491,0.623 2.618,0.936 2.618,1.304 C2.618,1.672 2.491,1.984 2.241,2.232 C1.991,2.481 1.677,2.608 1.309,2.608 C0.94,2.608 0.627,2.481 0.378,2.232 C0.127,1.984 0,1.672 0,1.304 C0,0.937 0.127,0.624 0.378,0.375 C0.626,0.127 0.94,0 1.309,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9996,0 L24.9996,24.005 L0,24.005 L0,0 L24.9996,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.069,0 C23.562,0 24.011,0.2 24.405,0.593 C24.8,0.986 25,1.434 25,1.924 L25,18.029 C25,18.519 24.8,18.967 24.405,19.361 C24.011,19.754 23.562,19.954 23.069,19.954 L5.067,19.954 L1.207,23.798 C0.761,24.243 0,23.927 0,23.297 L0,1.924 C0,1.433 0.196,0.986 0.579,0.593 C0.962,0.2 1.417,0 1.932,0 Z M23.004,1.989 L1.997,1.989 L1.997,20.196 L4.235,17.964 L23.004,17.964 L23.004,1.989 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.2833 8.579399999999998)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2.619,0 2.619,2.608 0,2.608 0,0",
    stroke: "none",
    fill: "#000000"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.7812 8.579399999999998)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2.619,0 2.619,2.608 0,2.608 0,0",
    stroke: "none",
    fill: "#000000"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.5685 8.579399999999998)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 2.618,0 2.618,2.608 0,2.608 0,0",
    stroke: "none",
    fill: "#000000"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.00039999999999906777 -0.0008000000000016882)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.0004,0.0008 25,0.0008 25,24.0058 0.0004,24.0058 0.0004,0.0008",
    stroke: "none",
    fill: "#000000"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSupport);
export default __webpack_public_path__ + "static/media/dashboard_support.c6a1a5f0a8871ad307eea2049f65607c.svg";
export { ForwardRef as ReactComponent };